import api from './utilBackoffice';

const controller = 'CarteiraAtraso';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },

  CarteirasDisponiveis: dto => {
    return api.Axios.GetParams(url + '/CarteirasDisponiveis', dto);
  },

  Create: dto => {
    return api.Axios.Post(url, dto);
  },

  Update: dto => {
    return api.Axios.PutCommand(url, dto);
  },

  Delete: dto => {
    return api.Axios.DeleteCommand(url, dto);
  }
});
